export default "__VITE_ASSET__CMolL51Z__"